import styled, { css } from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

import Time from '../../../assets/images/icon-time.svg';

export const TimeIcon = styled(Time)`
  display: block;
  margin: 0 auto 4px;
`;

export const Wrapper = styled.div<{ isMobileVersion?: boolean }>`
  padding: ${OFFSET.S} ${OFFSET.XS};
  margin: ${OFFSET.S};
  border-top: 1px solid ${COLORS.SILVER};
  border-bottom: 1px solid ${COLORS.SILVER};
  text-align: center;
  display: flex;
  align-items: center;

  ${media.mobile} {
    margin: ${OFFSET.S} 0;
    flex-direction: column;
    ${({ isMobileVersion }) =>
      isMobileVersion &&
      css`
        display: none;
      `};
  }
`;
